import { BAILocale } from '.';
import zh_TW from 'antd/es/locale/zh_TW';

const localeValue: BAILocale = {
  lang: 'zh-TW',
  antdLocale: zh_TW,
};

export default localeValue;
